"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isListMessages = exports.isFocusChatInput = void 0;
var _reselect = require("reselect");
var _types = require("../actions/types");
var uiSelector = function uiSelector(_ref) {
  var ui = _ref.ui;
  return ui.message;
};
var isListMessages = exports.isListMessages = (0, _reselect.createSelector)(uiSelector, function (ui) {
  return ui === _types.UI.LIST_MESSAGES;
});
var isFocusChatInput = exports.isFocusChatInput = (0, _reselect.createSelector)(uiSelector, function (ui) {
  return ui === _types.UI.FOCUS_CHAT_INPUT;
});